import React, { ReactElement, useEffect, useState } from 'react';
import { Platform, View, ViewStyle, useWindowDimensions } from 'react-native';

import { getMaxWidth, getPadding } from './utilities';

interface IProps {
  size: 's' | 'm' | 'l';
  style?: ViewStyle;
  children?: React.ReactNode;
  noFlex?: boolean;
}

export default function KitContainer({
  size = 'm',
  style = {},
  children,
  noFlex,
}: IProps): ReactElement {
  const { width } = useWindowDimensions();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Only run on client-side after hydration
    if (typeof window !== 'undefined') {
      setIsClient(true);
    }
  }, []);

  // Use dynamic width only after hydration on web, always on native
  const resolvedWidth =
    Platform.OS === 'web' && !isClient ? getMaxWidth(size) : width;

  const paddingHorizontal = getPadding(size, resolvedWidth);

  /**
   * RN sizes boxes with "border-box", so we need to add the padding to the
   * width to size container properly.
   */
  const maxWidth = getMaxWidth(size) + paddingHorizontal * 2;

  return (
    <View
      style={{
        alignItems: 'center',
        flex: noFlex ? undefined : 1,
      }}
    >
      <View
        style={{
          ...style,
          paddingHorizontal,
          maxWidth,
          width: '100%',
        }}
      >
        {children}
      </View>
    </View>
  );
}
